import React from 'react';
import { FiTrash2 } from 'react-icons/fi';
import DatalistInput from './DatalistInput';
import CollapsiblePaginatedPanel from './CollapsiblePaginatedPanel';
import { emptySubServerRow, inputClassName } from '../../utils/assetHelpers';
import DomainMultiSelect from './DomainMultiSelect';

const SubServerEditor = ({
    rows,
    onChange,
    statuses = [],
    subServerTypes = [],
    estCurrencies = [],
    domainAssets = [],
}) => {
    const updateRow = (absoluteIndex, field, value) => {
        const next = rows.map((row, i) => (i === absoluteIndex ? { ...row, [field]: value } : row));
        onChange(next);
    };

    const removeRow = (absoluteIndex) => {
        onChange(rows.filter((_, i) => i !== absoluteIndex));
    };

    const latest = rows[rows.length - 1];
    const summaryDetail = latest
        ? `Latest: ${latest.name || 'Unnamed'}${latest.type ? ` (${latest.type})` : ''}${latest.estMonthlyPaymentAmount !== '' && latest.estMonthlyPaymentAmount != null ? ` · ${latest.estMonthlyPaymentCurrency || ''} ${latest.estMonthlyPaymentAmount}` : ''}`
        : '';

    return (
        <CollapsiblePaginatedPanel
            title="Sub Servers"
            items={rows}
            countLabel="sub server"
            summaryDetail={summaryDetail}
            addLabel="Add sub server"
            onAdd={() => onChange([...rows, emptySubServerRow()])}
            emptyText="No sub servers yet."
        >
            {(visibleRows, startIndex) =>
                visibleRows.map((row, index) => {
                    const absoluteIndex = startIndex + index;
                    return (
                        <div
                            key={`sub-server-${absoluteIndex}`}
                            className="grid grid-cols-1 md:grid-cols-3 gap-3 border-b border-gray-100 pb-3 last:border-b-0 last:pb-0"
                        >
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                                <input
                                    type="text"
                                    value={row.name}
                                    onChange={(e) => updateRow(absoluteIndex, 'name', e.target.value)}
                                    className={inputClassName}
                                />
                            </div>
                            <DatalistInput
                                id={`sub-server-type-${absoluteIndex}`}
                                label="Type"
                                value={row.type}
                                onChange={(value) => updateRow(absoluteIndex, 'type', value)}
                                options={subServerTypes}
                            />
                            <DatalistInput
                                id={`sub-server-status-${absoluteIndex}`}
                                label="Status"
                                value={row.status}
                                onChange={(value) => updateRow(absoluteIndex, 'status', value)}
                                options={statuses}
                            />
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Login ID</label>
                                <input
                                    type="text"
                                    value={row.loginID}
                                    onChange={(e) => updateRow(absoluteIndex, 'loginID', e.target.value)}
                                    className={inputClassName}
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Login Password</label>
                                <input
                                    type="text"
                                    value={row.loginPass}
                                    onChange={(e) => updateRow(absoluteIndex, 'loginPass', e.target.value)}
                                    className={inputClassName}
                                />
                            </div>
                            <DatalistInput
                                id={`sub-server-currency-${absoluteIndex}`}
                                label="Est. Monthly Currency"
                                value={row.estMonthlyPaymentCurrency}
                                onChange={(value) => updateRow(absoluteIndex, 'estMonthlyPaymentCurrency', value)}
                                options={estCurrencies}
                            />
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Est. Monthly Amount</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    min="0"
                                    value={row.estMonthlyPaymentAmount}
                                    onChange={(e) => updateRow(absoluteIndex, 'estMonthlyPaymentAmount', e.target.value)}
                                    className={inputClassName}
                                />
                            </div>
                            <div className="md:col-span-3">
                                <label className="block text-sm font-medium text-gray-700 mb-1">Linked Domains</label>
                                <DomainMultiSelect
                                    selectedIds={row.domains || []}
                                    onChange={(ids) => updateRow(absoluteIndex, 'domains', ids)}
                                    domainAssets={domainAssets}
                                />
                            </div>
                            <div className="flex items-end md:col-span-3">
                                <button
                                    type="button"
                                    onClick={() => removeRow(absoluteIndex)}
                                    className="inline-flex items-center gap-1 px-3 py-2 text-red-600 hover:text-red-800"
                                >
                                    <FiTrash2 className="w-4 h-4" />
                                    Remove
                                </button>
                            </div>
                        </div>
                    );
                })
            }
        </CollapsiblePaginatedPanel>
    );
};

export default SubServerEditor;
